'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaLaptop = function FaLaptop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.6 28q-1.3 0-2.3-1t-1-2.3v-14.7q0-1.3 1-2.3t2.3-1h22.6q1.4 0 2.4 1t1 2.3v14.7q0 1.3-1 2.3t-2.4 1h-22.6z m-0.6-18v14.7q0 0.2 0.2 0.4t0.4 0.2h22.6q0.3 0 0.5-0.2t0.2-0.4v-14.7q0-0.2-0.2-0.4t-0.5-0.2h-22.6q-0.2 0-0.4 0.2t-0.2 0.4z m28.5 19.3h3.4v2q0 0.8-1 1.4t-2.4 0.6h-33.2q-1.3 0-2.3-0.6t-1-1.4v-2h36.5z m-14.9 2q0.3 0 0.3-0.3t-0.3-0.4h-3.3q-0.4 0-0.4 0.4t0.4 0.3h3.3z' })
        )
    );
};

exports.default = FaLaptop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/laptop.js
// module id = 1545
// module chunks = 0